import cx from 'classnames';
import useKeyWithInterval from '~/hooks/common/ui/useKeyWithInterval';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { OriginalPrice, PriceWrapper, StyledPrice } from './Price.styles';

export default function NewVehiclePrice() {
  const priceKey = useKeyWithInterval();
  const { finalPrice, originalPrice } = useVehiclePrice();
  const hasDiscount = originalPrice > finalPrice;

  return (
    <PriceWrapper>
      <StyledPrice key={priceKey}>
        ${formatAndDropDecimal(finalPrice)}
      </StyledPrice>
      <OriginalPrice>
        MSRP{' '}
        <span className={cx({ 'line-through': hasDiscount })}>
          ${formatAndDropDecimal(originalPrice)}
        </span>
      </OriginalPrice>
    </PriceWrapper>
  );
}
